import {
  AttendanceRecordsDataTypes,
  CreateAttendanceRecordsParams,
  GetAttendanceRecordsDetailParams,
  ImportAttendanceRecordsRequestType,
  ImportAttendanceRecordsResponseType,
  UpdateAttendanceRecordsParams
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getAllAttendanceRecordsService = async (
  params?: BaseFilterParams & { _payrollPeriodId: string },
): Promise<AttendanceRecordsDataTypes[]> => {
  const res = await axiosInstance.get('attendance-records', { params });
  return res.data.data;
};

export const getAttendanceRecordsByIdService = async (
  params: GetAttendanceRecordsDetailParams
): Promise<AttendanceRecordsDataTypes> => {
  const res = await axiosInstance.get('attendance-records/detail', { params });
  return res.data.data;
};

export const createAttendanceRecordsService = async (
  params: CreateAttendanceRecordsParams,
): Promise<{ id: number, workingDateWarning: boolean }> => {
  const res = await axiosInstance.post('attendance-records', params);
  return res.data.data;
};

export const updateNoteAttendanceRecordsService = async (
  params: UpdateAttendanceRecordsParams,
): Promise<{ id: number }> => {
  const res = await axiosInstance.put('attendance-records/update-note', params);
  return res.data.data;
};

export const exportAttendanceRecordsService = async (
  params: { _payrollPeriodId: number },
): Promise<{ link: string }> => {
  const res = await axiosInstance.post('attendance-records/export', params);
  return res.data.data;
};

export const importAttendanceRecordsService = async (
  params: ImportAttendanceRecordsRequestType & { payrollPeriodId: number },
): Promise<ImportAttendanceRecordsResponseType> => {
  const bodyForm = new FormData();
  bodyForm.append('file', params.file);
  bodyForm.append('preview', params.preview ? '1' : '0');

  const res = await axiosInstance.post('attendance-records/import', bodyForm, {
    params: {
      _payrollPeriodId: params.payrollPeriodId,
    },
  });
  return res.data.data;
};
